export default {
  NOT_STARTED: 'Not started',
  STARTED: 'Started',
  ENDED: 'Ended'
}
